// 🔧 footer.js
// ✅ Purpose: Unified global footer component used across Let's Go Vote
// ✅ Features:
// - Adds SEO-friendly footer navigation
// - Links to industry solution landing pages
// - Links to request event page
// - Includes compact contact form module
// - Keeps copyright year automatically updated
// - Uses consistent Bootstrap layout

import React from "react";
import { Link } from "react-router-dom";
import FooterWithContactForm from "./FooterWithContactForm";
import { SOCIAL_LINKS } from "../constants/social_links";

const Footer = () => {
  return (
    <footer id="footer" className="container-fluid bg-dark text-white mt-5">
      <div className="container py-5">
        <div className="row g-4 text-start">

          <div className="col-md-3">
            <h5 className="fw-bold">Let&apos;s Go Vote</h5>

            <p className="text-white-50 mb-3">
              QR-code voting, event ballots, silent auctions, sponsors,
              volunteers, and results tools for real-world events.
            </p>

            <Link to="/request_event" className="btn btn-primary btn-sm">
              Request Your Event
            </Link>

            <FooterWithContactForm />
          </div>

          <div className="col-md-2">
            <h6 className="fw-bold">Explore</h6>

            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="text-white-50 text-decoration-none">
                  Home
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to="/how-it-works"
                  className="text-white-50 text-decoration-none"
                >
                  How It Works
                </Link>
              </li>

              <li className="mb-2">
                <Link to="/solutions" className="text-white-50 text-decoration-none">
                  Solutions
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/#pricing" className="text-white-50 text-decoration-none">
                  Pricing
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/about" className="text-white-50 text-decoration-none">
                  About
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-white-50 text-decoration-none">
                  Contact
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/privacy" className="text-white-50 text-decoration-none">
                  Privacy Policy
                </Link>
              </li>

            </ul>
          </div>

          <div className="col-md-3">
            <h6 className="fw-bold">Features</h6>

            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/qr-code-voting" className="text-white-50 text-decoration-none">
                  QR Code Voting
                </Link>
              </li>

              <li className="mb-2">
                <Link to="/peoples-choice-voting" className="text-white-50 text-decoration-none">
                  People&apos;s Choice Voting
                </Link>
              </li>

              <li className="mb-2">
                <Link to="/ranked-choice-voting" className="text-white-50 text-decoration-none">
                  Ranked Choice Voting
                </Link>
              </li>

              <li className="mb-2">
                <Link to="/judged-scorecards" className="text-white-50 text-decoration-none">
                  Judged Scorecards
                </Link>
              </li>

              <li className="mb-2">
                <Link to="/volunteer-management" className="text-white-50 text-decoration-none">
                  Volunteer Management
                </Link>
              </li>

              <li className="mb-2">
                <Link to="/sponsor-management" className="text-white-50 text-decoration-none">
                  Sponsor Management
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-md-3">
            <h6 className="fw-bold">Solutions</h6>

            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/car-shows" className="text-white-50 text-decoration-none">
                  Car Shows
                </Link>
              </li>

              <li className="mb-2">
                <Link to="/art-shows" className="text-white-50 text-decoration-none">
                  Art Shows
                </Link>
              </li>

              <li className="mb-2">
                <Link to="/pet-shows" className="text-white-50 text-decoration-none">
                  Pet Shows
                </Link>
              </li>

              <li className="mb-2">
                <Link to="/school-elections" className="text-white-50 text-decoration-none">
                  School Elections
                </Link>
              </li>

              <li className="mb-2">
                <Link to="/silent-auctions" className="text-white-50 text-decoration-none">
                  Silent Auctions
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-md-3">
            <h6 className="fw-bold">Contact</h6>

            <p className="text-white-50 mb-2">
              hello@letsgovote.app
            </p>

            <p className="text-white-50 mb-0">
              No app downloads. No complicated setup. Just login, scan, vote, and enjoy the event.
            </p>
          </div>
        </div>

        <div className="mt-3">
          <h6 className="fw-bold">Follow Us</h6>

          <ul className="list-unstyled">
            <li className="mb-2">
              <a
                href={SOCIAL_LINKS.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white-50 text-decoration-none"
              >
                Facebook
              </a>
            </li>

            <li className="mb-2">
              <a
                href={SOCIAL_LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white-50 text-decoration-none"
              >
                Instagram
              </a>
            </li>

            <li className="mb-2">
              <a
                href={SOCIAL_LINKS.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white-50 text-decoration-none"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>

        <hr className="border-secondary my-4" />

        <div className="row">
          <div className="col text-center">
            <p className="text-white-50 small mb-0">
              © {new Date().getFullYear()} Let&apos;s Go Vote. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;